export default __webpack_public_path__ + "static/media/search-icon.d38cd26a.svg";